import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService, EModalSize, EToasterType, EToasterPosition } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { $types } from './FootPrintPortalManager.types'

import { FootPrintPortalManager_inventory_pallet_gridComponent } from './FootPrintPortalManager.inventory_pallet_grid.component';
import { FootPrintPortalManager_inventory_lot_gridComponent } from './FootPrintPortalManager.inventory_lot_grid.component';
import { FootPrintPortalManager_inventory_material_gridComponent } from './FootPrintPortalManager.inventory_material_grid.component';
import { FootPrintPortalManager_materials_by_base_packaging_gridComponent } from './FootPrintPortalManager.materials_by_base_packaging_grid.component';
import { FootPrintPortalManager_inventory_tasks_gridComponent } from './FootPrintPortalManager.inventory_tasks_grid.component';
import { Materials_materials_by_count_widgetComponent } from './Materials.materials_by_count_widget.component';
import { Inventory_total_packaged_amount_widgetComponent } from './Inventory.total_packaged_amount_widget.component';
import { Inventory_total_gross_weight_widgetComponent } from './Inventory.total_gross_weight_widget.component';
import { FootPrintPortalManager_inventory_aggregation_dd_singleComponent } from './FootPrintPortalManager.inventory_aggregation_dd_single.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootPrintPortalManager_inventory_pallet_gridComponent),
    forwardRef(() => FootPrintPortalManager_inventory_lot_gridComponent),
    forwardRef(() => FootPrintPortalManager_inventory_material_gridComponent),
    forwardRef(() => FootPrintPortalManager_materials_by_base_packaging_gridComponent),
    forwardRef(() => FootPrintPortalManager_inventory_tasks_gridComponent),
    forwardRef(() => Materials_materials_by_count_widgetComponent),
    forwardRef(() => Inventory_total_packaged_amount_widgetComponent),
    forwardRef(() => Inventory_total_gross_weight_widgetComponent),
    forwardRef(() => FootPrintPortalManager_inventory_aggregation_dd_singleComponent),
  ],
  selector: 'FootPrintPortalManager-single_project_hub',
  templateUrl: './FootPrintPortalManager.single_project_hub.component.html'
})
export class FootPrintPortalManager_single_project_hubComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { projectId: number, ownerId: number } = { projectId: null, ownerId: null };
  //#region Inputs
  @Input('projectId') set $inParams_projectId(v: number) {
    this.inParams.projectId = v;
  }
  get $inParams_projectId(): number {
    return this.inParams.projectId;
  }
  @Input('ownerId') set $inParams_ownerId(v: number) {
    this.inParams.ownerId = v;
  }
  get $inParams_ownerId(): number {
    return this.inParams.ownerId;
  }
  //#endregion Inputs

  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  vars: { hubTitle?: string, hubDescription?: string } = { };
  //#endregion
  formGroup: FormGroup = new FormGroup({
    inventory_type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
      create_material: new ToolModel(new ButtonModel('create_material', new ButtonStyles(null, null), false, 'Create material', 'ms-Icon ms-Icon--Add')
    ),
      email_rules: new ToolModel(new ButtonModel('email_rules', new ButtonStyles(null, null), false, 'Email rules', 'icon-ic_fluent_mail_alert_20_regular')
    )
  };

  actionbar = {
      ship_to_addresses: new ToolModel(new ButtonModel('ship_to_addresses', new ButtonStyles(null, null), false, 'Ship to contacts', 'ms-Icon ms-Icon--AddGroup')
    )
  };

 filters = {
    inventory_type: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['inventory_type'] as DatexFormControl, 
  ESelectBoxType.chips, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Inventory type', false)
,
  };


  filtersets = {
  newGroup1: new FieldsetModel('Label of newGroup1', true, false, true),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
      inventory: new TabGroupModel(),
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      inventory: new TabItemModel(
        this.rootTabGroup, 
        'Inventory', 
        true,
        {
          inventory_by_lp: new TabItemModel(
          this.subTabGroups.inventory, 
          'Inventory', 
          ),
          inventory_by_lot: new TabItemModel(
          this.subTabGroups.inventory, 
          'Inventory', 
          ),
          inventory_by_material: new TabItemModel(
          this.subTabGroups.inventory, 
          'Inventory', 
          ),
        }
        ),
      materials: new TabItemModel(
        this.rootTabGroup, 
        'Materials', 
        ),
      tasks: new TabItemModel(
        this.rootTabGroup, 
        'Activity', 
        ),
    };
  
    //#region tabs inParams
    get $tabs_inventory_inventory_by_lp_inventory_pallet_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.projectId;
      
      return expr;
    }
  
    get $tabs_inventory_inventory_by_lot_inventory_lot_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.projectId;
      
      return expr;
    }
  
    get $tabs_inventory_inventory_by_material_inventory_material_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.projectId;
      
      return expr;
    }
  
    get $tabs_materials_materials_by_base_packaging_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.projectId;
      
      return expr;
    }
  
    get $tabs_materials_materials_by_base_packaging_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.ownerId;
      
      return expr;
    }
  
    get $tabs_tasks_inventory_tasks_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.projectId;
      
      return expr;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
        @ViewChild('$tabs_inventory_inventory_by_lp', { read: FootPrintPortalManager_inventory_pallet_gridComponent }) $tabs_inventory_inventory_by_lp: FootPrintPortalManager_inventory_pallet_gridComponent;
        @ViewChild('$tabs_inventory_inventory_by_lot', { read: FootPrintPortalManager_inventory_lot_gridComponent }) $tabs_inventory_inventory_by_lot: FootPrintPortalManager_inventory_lot_gridComponent;
        @ViewChild('$tabs_inventory_inventory_by_material', { read: FootPrintPortalManager_inventory_material_gridComponent }) $tabs_inventory_inventory_by_material: FootPrintPortalManager_inventory_material_gridComponent;
      @ViewChild('$tabs_materials', { read: FootPrintPortalManager_materials_by_base_packaging_gridComponent }) $tabs_materials: FootPrintPortalManager_materials_by_base_packaging_gridComponent;
      @ViewChild('$tabs_tasks', { read: FootPrintPortalManager_inventory_tasks_gridComponent }) $tabs_tasks: FootPrintPortalManager_inventory_tasks_gridComponent;
    //#endregion tabs children
    widgets = {
      materials_by_count_widget: new WidgetModel(),
      total_packaged_amount_widget: new WidgetModel(),
      total_gross_weight_widget: new WidgetModel(),
    };
  
    //#region widgets inParams
    get $widgets_materials_by_count_widget_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.projectId;
      
      return expr;
    }
  
    get $widgets_total_packaged_amount_widget_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.projectId;
      
      return expr;
    }
  
    get $widgets_total_gross_weight_widget_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.projectId;
      
      return expr;
    }
  
    //#endregion widgets inParams
  
    //#region widgets children
      @ViewChild('$widgets_materials_by_count_widget', { read:  Materials_materials_by_count_widgetComponent }) $widgets_materials_by_count_widget: Materials_materials_by_count_widgetComponent;
      @ViewChild('$widgets_total_packaged_amount_widget', { read:  Inventory_total_packaged_amount_widgetComponent }) $widgets_total_packaged_amount_widget: Inventory_total_packaged_amount_widgetComponent;
      @ViewChild('$widgets_total_gross_weight_widget', { read:  Inventory_total_gross_weight_widgetComponent }) $widgets_total_gross_weight_widget: Inventory_total_gross_weight_widgetComponent;
    //#endregion widgets children

  //#region filters inParams
  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return $hub.vars.hubTitle;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return $hub.vars.hubDescription;
  }

  constructor(
  private utils: UtilsService,
  private settings: SettingsValuesService,
  private shell: FootPrintPortalManager_ShellService,
  private datasources: FootPrintPortalManager_DatasourceService,
  private flows: FootPrintPortalManager_FlowService,
  private reports: FootPrintPortalManager_ReportService,
  private localization: FootPrintPortalManager_LocalizationService,
  private operations: FootPrintPortalManager_OperationService,
  ) { 
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.inventory,
      this.tabs.materials,
      this.tabs.tasks,
    ]; 
    this.subTabGroups.inventory.tabs = [
        this.tabs.inventory.tabs.inventory_by_lp,
        this.tabs.inventory.tabs.inventory_by_lot,
        this.tabs.inventory.tabs.inventory_by_material,
    ];    
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if(!this.$hasMissingRequiredInParams) {
      this.$init();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      }
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }
  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.projectId)) {
        this.$missingRequiredInParams.push('projectId');
      }
      if(isNil(this.inParams.ownerId)) {
        this.$missingRequiredInParams.push('ownerId');
      }
  }



  initialized = false;

  async $init() {
    this.title = 'Single Project Hub';
    
    const $hub = this;
    const $utils = this.utils;

    (this.filters.inventory_type.control as SelectBoxModel).reset(4);

    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.formGroup
      .controls['inventory_type']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_inventory_type_change();
      });
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region widgets children
    if (childToSkip !== '$widgets_materials_by_count_widget') {
      if (!isNil(this.$widgets_materials_by_count_widget) && !this.widgets.materials_by_count_widget.hidden) {
        this.$widgets_materials_by_count_widget.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$widgets_total_packaged_amount_widget') {
      if (!isNil(this.$widgets_total_packaged_amount_widget) && !this.widgets.total_packaged_amount_widget.hidden) {
        this.$widgets_total_packaged_amount_widget.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$widgets_total_gross_weight_widget') {
      if (!isNil(this.$widgets_total_gross_weight_widget) && !this.widgets.total_gross_weight_widget.hidden) {
        this.$widgets_total_gross_weight_widget.refresh(true, false, null);
      }
    }
    //#endregion widgets children
    //#region tabs children
      if (childToSkip !== '$tabs_inventory_inventory_by_lp') {
        if (!isNil(this.$tabs_inventory_inventory_by_lp) && !this.tabs.inventory.tabs.inventory_by_lp.hidden) {
          this.$tabs_inventory_inventory_by_lp.refresh(true, false, null);
        }
      }   
      if (childToSkip !== '$tabs_inventory_inventory_by_lot') {
        if (!isNil(this.$tabs_inventory_inventory_by_lot) && !this.tabs.inventory.tabs.inventory_by_lot.hidden) {
          this.$tabs_inventory_inventory_by_lot.refresh(true, false, null);
        }
      }   
      if (childToSkip !== '$tabs_inventory_inventory_by_material') {
        if (!isNil(this.$tabs_inventory_inventory_by_material) && !this.tabs.inventory.tabs.inventory_by_material.hidden) {
          this.$tabs_inventory_inventory_by_material.refresh(true, false, null);
        }
      }   
    if (childToSkip !== '$tabs_materials') {
      if (!isNil(this.$tabs_materials) && !this.tabs.materials.hidden) {
        this.$tabs_materials.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_tasks') {
      if (!isNil(this.$tabs_tasks) && !this.tabs.tasks.hidden) {
        this.$tabs_tasks.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootPrintPortalManager_single_project_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  const project = (await $datasources.Owners.ds_get_project_by_projectId.get({ projectId: $hub.inParams.projectId })).result;
  if ($utils.isDefined(project)) {
  
      $hub.title = `Project ${project[0].LookupCode}`;
  
      const title = `Project ${project[0].LookupCode} - Status ${project[0].Status.Label}`;
  
      if ($utils.isDefined(project[0].Notes)) {
          const description = `${project[0].Notes}  `;
          $hub.vars.hubDescription = description;
      }
  
      $hub.vars.hubTitle = title;
  
  }
  
  // Initialize the inventory aggregation filter
  await $hub.on_inventory_type_change();
  
  
  await $hub.on_apply_operations();
  }
  on_create_material_clicked(event = null) {
    return this.on_create_material_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_create_material_clickedInternal(
    $hub: FootPrintPortalManager_single_project_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  
  
  const dialogResult = (await $shell.FootPrintPortalManager.openmaterial_creation_formDialog({
      projectId: $hub.inParams.projectId
      }));
  const userConfirm = dialogResult.confirm;
  if (userConfirm){
      await $hub.refresh();
  }
  }
  on_ship_to_contacts_clicked(event = null) {
    return this.on_ship_to_contacts_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_ship_to_contacts_clickedInternal(
    $hub: FootPrintPortalManager_single_project_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const project = (await $datasources.Owners.ds_get_project_by_projectId.get({projectId: $hub.inParams.projectId})).result;
  if ($utils.isDefined(project)){
  
      const ownerId = project[0].OwnerId
  
  $shell.FootPrintPortalManager.openownersaccounts_gridDialog({
      ownerId:  ownerId,
      typeIds: [2,4,5],
      accountTypeId: 2,
      allowSelection:  false
  })
  
  }
  else {
      throw new Error ('Unable to determine owner from given project.')
  }
  
  }
  on_inventory_type_change(event = null) {
    return this.on_inventory_type_changeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_inventory_type_changeInternal(
    $hub: FootPrintPortalManager_single_project_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  var inventoryType = $hub.filters.inventory_type.control.value;
  
  if (inventoryType == 2) {
      $hub.tabs.inventory.tabs.inventory_by_lp.hidden = false;
      $hub.tabs.inventory.tabs.inventory_by_lp.activate();
  
  
      $hub.tabs.inventory.tabs.inventory_by_lot.hidden = true;
      $hub.tabs.inventory.tabs.inventory_by_material.hidden = true;
  
  
  }
  else if (inventoryType == 3) {
      $hub.tabs.inventory.tabs.inventory_by_lot.hidden = false;
      $hub.tabs.inventory.tabs.inventory_by_lot.activate();
  
      $hub.tabs.inventory.tabs.inventory_by_lp.hidden = true;
      $hub.tabs.inventory.tabs.inventory_by_material.hidden = true;
  
  }
  else if (inventoryType == 4) {
      $hub.tabs.inventory.tabs.inventory_by_material.hidden = false;
      $hub.tabs.inventory.tabs.inventory_by_material.activate();
  
  
      $hub.tabs.inventory.tabs.inventory_by_lp.hidden = true;
      $hub.tabs.inventory.tabs.inventory_by_lot.hidden = true;
  
  }
  }
  on_apply_operations(event = null) {
    return this.on_apply_operationsInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_apply_operationsInternal(
    $hub: FootPrintPortalManager_single_project_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  // Apply operations
  if (await $operations.FootPrintPortalManager.Disable_Project_Activity.isAuthorized()){
      $hub.tabs.tasks.hidden = true;
  }
  
  if (await $operations.FootPrintPortalManager.Disable_Inventory_Activity.isAuthorized()){
      $hub.tabs.inventory.hidden = true;
  }
  
  
  if (await $operations.FootPrintPortalManager.Disable_Material_Creation.isAuthorized()){
      $hub.toolbar.create_material.hidden = true;
  }
  
  
  if (await $operations.FootPrintPortalManager.Disable_Project_ManageShipToContacts.isAuthorized()){
      $hub.actionbar.ship_to_addresses.hidden = true;
  }
  
  if (await $operations.FootPrintPortalManager.Disable_EmailRules_Management.isAuthorized()){
      $hub.toolbar.email_rules.hidden = true;
  }
  
  
  
  
  }
  on_email_rules(event = null) {
    return this.on_email_rulesInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_email_rulesInternal(
    $hub: FootPrintPortalManager_single_project_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  await $shell.Notifications.openauto_email_rules_grid({
      projectId: $hub.inParams.projectId
  });
  }
  //#endregion private flows
}
